module.exports.formatMoney = (value) => {
    if(value === undefined || value === null) return '';

    return value.toLocaleString('en-IN', {minimumFractionDigits: 2});
}

module.exports.accountLabel = (option) => {
    if (!option.name) return option.title;

    return `${option.unit ? `${option.unit} - ` : ''}${option.name} - ${option.code}`;
}
